export default {
    empty: "empty",
    success: "success",
    error: "error",
    loading: "loading",
};
